<script>
    import Layout from '../layout/simple.svelte';

    import OrderModal from '../modals/order.svelte';

    import Tab_All from './archive/all.svelte';
    import Tab_Mine from './archive/mine.svelte';

    //import archive from '../state/archive.js';
    import user from '../state/user.js';

    // Load logged-in user data
    user.load();

    let tabs = {
        all: {
            caption: 'Všechny lekce',
            path: '/',
            component: Tab_All
        },
        mine: {
            caption: 'Mé lekce',
            path: '/moje',
            component: Tab_Mine
        }
    };

    export let page = null;

    let currentTab = 'all';
    if (page && tabs.hasOwnProperty(page)) {
        currentTab = page;
    }
</script>

<style>
    .contents {
        flex: 1;
        padding: 10px;
        background: white;
    }
</style>

<Layout page="archive">
    <div class="contents">
        <div class="tabs is-centered is-boxed">
            <ul>
                {#each Object.entries(tabs) as [key, tab] (key)}
                    <li class:is-active={key === currentTab}>
                        <a href="/archiv{tab.path}">{tab.caption}</a>
                    </li>
                {/each}
            </ul>
        </div>

        <svelte:component this={tabs[currentTab].component} />
    </div>

    <OrderModal />
</Layout>